@if (isLoading) {
  <div class="loading-state">
    <p>Loading...</p>
  </div>
} @else {
  @if (data?.length) {
    @for (info of data; track info) {
      <div class="info-content">
        <div class="heading">
          <label>{{info.propertyName}}</label>
        </div>
        <div class="value">
          <p class="info">{{info.propertyValue}}</p>
          <p class="info-sub">{{info.date}}</p>
          <p class="info-sub">{{info.numOfFatalities}}</p>
          <p class="info-sub">{{info.numOfInjuries}}</p>
          <p class="info-sub">{{info.chemicalsSpilt}}</p>
          <div class="line"></div>
        </div>
      </div>
    }
  } @else {
    <div class="no-record">
      <p>No Records</p>
    </div>
  }
}